// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Picture__Wrapper_3FLxK","Image":"Picture__Image_2SoFd","Caption":"Picture__Caption_P_Eo8","Link":"Picture__Link_2Ktn2"};